import React from "react";
import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub, BsFillRocketTakeoffFill } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";

function ProjectCards(props) {
  const navigate = useNavigate();

  // Handle click for internal navigation
  const handleInternalNavigation = (path) => {
    if (path.startsWith('/')) {
      navigate(path);
    }
  };

  return (
    <Card className="project-card-view">
      <Card.Img 
        variant="top" 
        src={props.imgPath} 
        alt="card-img" 
        style={props.demoLink?.startsWith('/') ? { cursor: 'pointer' } : {}}
        onClick={props.demoLink?.startsWith('/') ? 
          () => handleInternalNavigation(props.demoLink) : 
          undefined}
      />
      <Card.Body>
        <Card.Title 
          style={props.demoLink?.startsWith('/') ? { cursor: 'pointer' } : {}}
          onClick={props.demoLink?.startsWith('/') ? 
            () => handleInternalNavigation(props.demoLink) : 
            undefined}
        >
          {props.title}
        </Card.Title>
        <Card.Text style={{ }}>
          {props.description}
        </Card.Text>
        {!props.isPrivate && props.ghLink && (
          <Button variant="primary" href={props.ghLink} target="_blank">
            <BsGithub /> &nbsp;
            {"GitHub"}
          </Button>
        )}
        {"\n"}
        {"\n"}

        {/* For internal links (NuroFit) */}
        {props.demoLink && props.demoLink.startsWith('/') && (
          <Button
            variant="primary"
            onClick={() => handleInternalNavigation(props.demoLink)}
            style={{ marginLeft: props.ghLink ? "10px" : "0" }}
          >
            <CgWebsite /> &nbsp;
            {"View Project"}
          </Button>
        )}

        {/* For external demo links */}
        {props.demoLink && !props.demoLink.startsWith('/') && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: props.ghLink ? "10px" : "0" }}
          >
            <BsFillRocketTakeoffFill /> &nbsp;
            {"Live Demo"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
ProjectCards.propTypes = {
  imgPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ghLink: PropTypes.string,
  demoLink: PropTypes.string,
  isPrivate: PropTypes.bool
};

export default ProjectCards;
